import { COURSES, CERT_LEVELS } from '@/data/content';

const colorMap: Record<string, { border: string; bg: string; text: string }> = {
 'board-a': { border: 'border-board-a/30', bg: 'bg-board-a/8', text: 'text-board-a' },
 'board-b': { border: 'border-board-b/30', bg: 'bg-board-b/8', text: 'text-board-b' },
 'board-c': { border: 'border-board-c/30', bg: 'bg-board-c/8', text: 'text-board-c' },
 'board-s': { border: 'border-board-s/30', bg: 'bg-board-s/8', text: 'text-board-s' },
};

// Knowledge points extracted from 课程知识大纲 v0.5
const KNOWLEDGE = {
 junior: [
 { part: '底盘与对称', concept: '左右对称安装，不对称会跑偏', subject: '数学', color: '#00C2FF' },
 { part: '马达与力', concept: '力是"推"——马达转起来推齿轮，齿轮推轮子，轮子推地面', subject: '物理', color: '#FF3B3B' },
 { part: '轮胎与摩擦力', concept: '光滑胎滑得快但抓地力小，粗糙胎抓地力大但慢', subject: '物理', color: '#FF3B3B' },
 { part: '电池与重心', concept: '电池放低处更稳——重心越低越不容易翻', subject: '物理', color: '#FF3B3B' },
 { part: '保险杠与缓冲', concept: '橡胶变形"吃掉"撞击能量——延长撞击时间=减小撞击力', subject: '物理', color: '#FF3B3B' },
 { part: '红外传感器', concept: '红外线看不见，但它能"摸"到前面的东西——靠反射', subject: '物理', color: '#FF3B3B' },
 { part: 'IMU 陀螺仪', concept: '人能闭眼感知倾斜，陀螺仪也能——耳朵里就有"陀螺仪"', subject: '物理', color: '#FF3B3B' },
 { part: '编程入门', concept: '程序=指令清单，一条一条告诉小车做什么', subject: '信息技术', color: '#FFB800' },
 { part: '条件判断', concept: 'if(前面有障碍)停车 else 继续——给小车的选择题', subject: '数学', color: '#00C2FF' },
 { part: '零件英文名', concept: 'Chassis / Motor / Wheel / Battery / Bumper / Sensor', subject: '英语', color: '#88929E' },
 { part: 'AI启蒙：条件判断', concept: 'if-else 是 AI 的最原始形态——小车自己做决定：前面有障碍就停，没有就继续', subject: '人工智能', color: '#A855F7' },
 { part: 'AI启蒙：事件触发', concept: '按键按下=事件发生→执行程序。传感器检测到→自动反应。"这是会思考的车"', subject: '人工智能', color: '#A855F7' },
 ],
 teen: [
 { part: '齿轮减速组', concept: '小齿轮转3圈大齿轮转1圈——速度慢了但力气大了10倍', subject: '物理', color: '#FF3B3B' },
 { part: '扭矩传递链', concept: '电机→齿轮→轮胎→地面——力在抓地力处被限制，轮胎先打滑', subject: '物理', color: '#FF3B3B' },
 { part: '齿轮比例', concept: '20:60=1:3，输入轴转3圈输出轴转1圈', subject: '数学', color: '#00C2FF' },
 { part: '振动与阻尼', concept: '硅胶柱变形"吃掉"振动——三层防护：硬壳+软垫+硬板', subject: '物理', color: '#FF3B3B' },
 { part: '电路基础', concept: '电压=水压，电流=水流，电阻=水管粗细', subject: '物理', color: '#FF3B3B' },
 { part: '超声波测距', concept: '声速340m/s，叫一声等回声，时间÷2×声速=距离', subject: '物理', color: '#FF3B3B' },
 { part: 'I²C通信', concept: '两根线让传感器和主板"对话"——SDA传数据，SCL打拍子', subject: '信息技术', color: '#FFB800' },
 { part: 'PID 控制直觉', concept: 'P=偏多少纠多少，I=偏差攒多了多加力，D=变化太快就刹车', subject: '数学', color: '#00C2FF' },
 { part: '杠杆与力的分解', concept: '推铲越低越能"铲起来"——力的作用点和方向决定效果', subject: '物理', color: '#FF3B3B' },
 { part: '动量定理', concept: '更重+更快=更大推力，但要取舍——重了跑得慢', subject: '物理', color: '#FF3B3B' },
 { part: 'AI决策：状态机', concept: '攻击态/防御态/搜索态自动切换——这是"最简单的 AI 大脑"', subject: '人工智能', color: '#A855F7' },
 { part: 'AI控制：PID', concept: 'P=偏多少纠多少 D=变化太快就刹车 I=偏差攒多了多加力——AI 控制的基础', subject: '人工智能', color: '#A855F7' },
 ],
 elite: [
 { part: 'RGB 色彩空间', concept: '每种颜色是 R/G/B 三个数字，阈值=只要这个范围的红色', subject: '物理', color: '#FF3B3B' },
 { part: '矩阵与图像', concept: '1080×720像素=1080行720列矩阵，每个格3个数', subject: '数学', color: '#00C2FF' },
 { part: '有限状态机', concept: '攻击态/防御态/搜索态——每种状态一套规则，条件触发转换', subject: '信息技术', color: '#FFB800' },
 { part: '行为树', concept: '根→分支→叶子，从上往下问：能攻击？→能→执行。不能？→能防御？', subject: '信息技术', color: '#FFB800' },
 { part: '强化学习', concept: '撞翻对手+1，被撞翻-1。做1000次后统计——哪种策略平均奖励最高？', subject: '数学', color: '#00C2FF' },
 { part: '卡尔曼滤波', concept: '两个不准的传感器加权平均，反而比单独任何一个都准', subject: '数学', color: '#00C2FF' },
 { part: 'CAN 总线', concept: '多设备同一根线通信，ID越小优先级越高', subject: '信息技术', color: '#FFB800' },
 { part: '爆发机制物理', concept: 'PWM 85%→100%，平均电压3.4V→4.0V，扭矩170→200 g·cm', subject: '物理', color: '#FF3B3B' },
 { part: '3D 建模', concept: '草图→拉伸→旋转→切割——画个面，拉出来就是体', subject: '通用技术', color: '#00E676' },
 { part: '工程设计循环', concept: '需求→设计→制作→测试→迭代——真正做工程和做作业的区别', subject: '通用技术', color: '#00E676' },
 { part: '计算机视觉', concept: 'OpenCV 颜色识别→轮廓检测→包围框→云台追踪——让车"看懂"对手', subject: '人工智能', color: '#A855F7' },
 { part: '神经网络部署', concept: '训练好的 YOLO 模型量化压缩→NPU 推理——端侧 AI，不依赖云端', subject: '人工智能', color: '#A855F7' },
 ],
};

const AI_PATHWAY = [
 { stage: '条件判断', age: '6-8岁', level: '通识', desc: 'if(前面有障碍) 停 else 继续——给小车的"选择题"。这是 AI 决策的最原始形态。', icon: '🔀' },
 { stage: '有限状态机', age: '10-12岁', level: '进阶', desc: '攻击态 / 防御态 / 搜索态——每种状态一套规则，条件触发转换。"最简单的 AI 大脑"。', icon: '🔁' },
 { stage: '行为树', age: '13-14岁', level: '高阶', desc: '比状态机更灵活——优先级、并行、条件回退。从"反应"升级为"策略"。', icon: '🌳' },
 { stage: '传感器融合', age: '14-15岁', level: '菁英', desc: '超声波+IMU+视觉——三个不完美的传感器，卡尔曼滤波加权平均后比任何一个都准。', icon: '🎯' },
 { stage: '计算机视觉', age: '14-15岁', level: '菁英', desc: 'OpenCV 颜色识别→轮廓检测→目标跟踪→云台追踪。让车"看懂"对手在哪。', icon: '👁️' },
 { stage: '强化学习', age: '15-16岁', level: '菁英', desc: '不给规则，让车自己试 1000 次。撞翻对手 +1，被撞翻 -1——统计哪种策略平均奖励最高。', icon: '🧠' },
 { stage: '端侧推理', age: '16+岁', level: '极客', desc: 'NPU 加速神经网络——YOLO 目标检测跑在 C 板上。模型量化、剪枝、部署——真正的 Edge AI。', icon: '⚡' },
 { stage: '集群智能', age: '16+岁', level: '极客', desc: '多车编队、任务分配、群体策略。不是一辆车在思考——是一个车队在协同决策。', icon: '🪐' },
];

const FUTURE_VISIONS = [
 { title: '无人驾驶车', desc: '从遥控到自主——OpenCV车道线识别 + 交通标志分类 + PID速度控制。', img: '/images/future_autonomous.webp', color: '#00C2FF' },
 { title: '物流配送机器人', desc: '自主导航穿越走廊和教室，二维码定位 + 超声波避障。给校长办公室送咖啡。', img: '/images/future_delivery.webp', color: '#FFB800' },
 { title: '火星探测车', desc: '六轮摇臂悬架 + 太阳能电池板 + 远程图传。模拟火星地表自主导航采样。', img: '/images/future_mars_rover.webp', color: '#FF3B3B' },
 { title: '人形轮式机器人', desc: '上半身双机械臂 + 下半身战车底盘。从"对战"进化到"服务"。', img: '/images/future_humanoid.webp', color: '#FF6D00' },
 { title: '轮式机器狗', desc: '四轮独立驱动 + 12自由度腿部关节 + 强化学习步态。从四轮到四足。', img: '/images/future_robotdog.webp', color: '#A855F7' },
 { title: '救援侦察机器人', desc: '红外热成像 + 气体传感器 + mesh自组网。灾难中搜寻被困人员。', img: '/images/future_rescue.webp', color: '#FF3B3B' },
 { title: 'SLAM 建图', desc: '激光雷达 + 深度摄像头实时构建场地地图。知道"我在哪、障碍在哪"。', img: '/images/future_slam.webp', color: '#00E676' },
 { title: '集群协作', desc: '多车编队、任务分配、群体策略。从单体智能到群体智能。', img: '/images/future_swarm.webp', color: '#88929E' },
 { title: '海洋探索机器人', desc: '密封舱体 + 水下推进器。从陆地驶入水中——珊瑚礁监测、管道巡检。', img: '/images/future_underwater.webp', color: '#00C2FF' },
 { title: 'AI 机器人工程师', desc: '从拼装到神经网络部署的职业路径。大学方向：机器人/人工智能/自动化。', img: '/images/future_career.webp', color: '#FFB800' },
];

export default function EducationPage() {
 return (
 <div >
 {/* ---- Video Hero ---- */}
 <div className="relative overflow-hidden w-full h-[540px] md:h-[660px] mb-8">
 <img src="/images/edu_junior.webp" alt="" className="absolute inset-0 w-full h-full object-cover md:hidden" />
<video autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover hidden md:block">
 <source src="/videos/build-timelapse.webm" type="video/webm" />
<source src="/videos/build-timelapse.mp4" type="video/mp4" />
 </video>
 <div className="absolute inset-0 bg-black/45" />
 <div className="absolute top-0 left-0 right-0 p-8 md:p-12 text-center bg-gradient-to-b from-black/60 to-transparent">
 <h1 className="text-2xl md:text-3xl font-extrabold text-white mb-3 drop-shadow-[0_0_30px_rgba(0,0,0,0.8)]">课程体系</h1>
 <p className="text-white/80 text-sm max-w-2xl mx-auto drop-shadow-lg sm:whitespace-nowrap">48 课时覆盖 6 大学科。先体验，后理解——知识是为了让车跑得更快、打得更猛。</p>
 </div>
 <div className="absolute bottom-0 left-0 right-0 p-6 md:p-10 bg-gradient-to-t from-black/70 via-black/30 to-transparent">
 <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
 {[{t:'先体验，后理解',d:'先把车拼好、让传感器读数据、让程序跑起来。看到现象之后才引出概念。'},{t:'英语不是背的',d:'每一次插拔传感器、每一次编写代码，都自然遇到英文术语。'},{t:'成长是目的',d:'比起一局胜负——昨天的车还在拐弯冲出去，今天已经能绕赛道跑3圈不出错了。'}].map((p)=>(<div key={p.t}><h3 className="text-sm font-semibold text-white mb-1">{p.t}</h3><p className="text-xs text-white/60 leading-relaxed">{p.d}</p></div>))}
 </div>
 </div>
 </div>

 {/* ---- Future Vision ---- */}
 <section className="px-6 py-12 max-w-6xl mx-auto">
 <h2 className="text-lg font-extrabold text-text-primary mb-2 text-center">从战车出发，去向何方</h2>
 <p className="text-xs text-text-secondary mb-8 text-center">模块化战车不是终点——它是通往机器人世界的第一个台阶。以下每一个方向，都是从这辆战车上自然生长出来的。</p>
 <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-4 mb-6">
 {FUTURE_VISIONS.map((v) => (
 <div key={v.title} className="bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt overflow-hidden">
 <div className="h-44 overflow-hidden border-b border-border-dark">
 <img src={v.img} alt={v.title} className="w-full h-full object-cover" />
 </div>
 <div className="p-5">
 <div className="flex items-center gap-2 mb-2"><div className="w-1.5 h-1.5 rounded-full" style={{backgroundColor: v.color}}/><h3 className="text-sm font-semibold text-text-primary">{v.title}</h3></div>
 <p className="text-xs text-text-secondary leading-relaxed">{v.desc}</p>
 </div>
 </div>
 ))}
 </div>
 </section>

 {/* ---- Knowledge Progression ---- */}
 <section className="px-6 py-12 max-w-6xl mx-auto">
 <h2 className="text-lg font-extrabold text-text-primary mb-2 text-center">项目进阶体系</h2>
 <p className="text-xs text-text-secondary mb-8 text-center">从第一颗螺丝到神经网络——每一阶段解锁新的能力和视野。</p>
 <div className="flex flex-col lg:flex-row gap-5 mb-8">
   {/* Left: 4 steps in 2x2 */}
   <div className="lg:w-3/5 grid grid-cols-2 gap-4">
     {COURSES.filter(c => c.id !== 'geek').map((course) => { const c = colorMap[course.color]; if (!c) return null; return (
     <div key={course.id} className="bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt overflow-hidden hover:border-arena-blue/40 transition-all">
       <div className="h-32 overflow-hidden"><img src={course.image} alt={course.title} className="w-full h-full object-cover"/></div>
       <div className="p-4">
         <div className="flex items-center gap-2 mb-2"><span className={`text-[10px] px-2 py-0.5 rounded-tag border ${c.border} ${c.bg} ${c.text}`}>{course.boardLink}</span><span className="text-[10px] text-text-disabled">{course.ageRange}</span><span className="text-[10px] text-arena-gold ml-auto">{course.lessons}课时</span></div>
         <h3 className="text-sm font-semibold text-text-primary mb-2">{course.title}</h3>
         <div className="flex flex-wrap gap-1 mb-3">{course.skills.map((s)=>(<span key={s} className="text-[10px] text-text-disabled bg-border-dark/50 px-1.5 py-0.5 rounded-tag">{s}</span>))}</div>
         <div className="pt-2 border-t border-border-dark"><span className="text-[10px] text-text-disabled mr-2">关联学科</span>{course.subjects.map((s)=>(<span key={s} className="text-[10px] text-text-secondary mr-1.5">{s}</span>))}</div>
       </div>
     </div>
     )})}
   </div>
   {/* Right: Geek course - full height */}
   {(() => { const geek = COURSES.find(c => c.id === 'geek'); if (!geek) return null; const gc = colorMap[geek.color];
   return (
   <div className="lg:w-2/5 bg-panel-dark/40 border border-arena-red/20 rounded-card-lg mecha-card mecha-bolt overflow-hidden hover:border-arena-red/40 transition-all flex flex-col">
     <div className="h-48 overflow-hidden"><img src={geek.image} alt={geek.title} className="w-full h-full object-cover"/></div>
     <div className="p-6 flex flex-col flex-1">
       <div className="flex items-center gap-2 mb-3"><span className={`text-[10px] px-2 py-0.5 rounded-tag border ${gc.border} ${gc.bg} ${gc.text}`}>{geek.boardLink}</span><span className="text-[11px] text-text-disabled">{geek.ageRange}</span><span className="text-[11px] text-arena-gold ml-auto">{geek.lessons > 0 ? geek.lessons+'课时' : '自由项目制'}</span></div>
       <h3 className="text-lg font-semibold text-text-primary mb-3">{geek.title}</h3>
       <div className="flex flex-wrap gap-1 mb-4">{geek.skills.map((s)=>(<span key={s} className="text-[10px] text-text-disabled bg-border-dark/50 px-1.5 py-0.5 rounded-tag">{s}</span>))}</div>
       <p className="text-xs text-text-secondary leading-relaxed mb-4 flex-1">面向大学社团和成人爱好者，不设固定课时。从自研整车到 ROS 机器人、从集群协作到 AI 研究——这里是"不设限"的创造空间。完成菁英后，你可以在这里开启真正的工程师生涯。</p>
       <div className="pt-3 border-t border-border-dark flex flex-wrap gap-2">
         {['自研整车', 'ROS2', '集群协作', 'AI 研究', '开源贡献', '创业孵化'].map((tag) => (<span key={tag} className="text-[10px] text-arena-red/70 bg-arena-red/10 px-2 py-1 rounded-tag">{tag}</span>))}
       </div>
       <div className="mt-3 text-[10px] text-text-disabled">关联学科：{geek.subjects.join(' / ')}</div>
     </div>
   </div>
   ); })()}
 </div>
 </section>

 {/* ---- Knowledge Points by Grade ---- */}
 <section className="px-6 py-12 max-w-6xl mx-auto">
 <h2 className="text-lg font-extrabold text-text-primary mb-2 text-center">知识脉络</h2>
 <p className="text-xs text-text-secondary mb-8 text-center">每一个零件都是一本教科书。孩子的手摸到哪个零件，脑子里就在学哪门课。</p>

 {/* 启蒙 1-2年级 */}
 <div className="mb-10">
 <div className="flex items-center gap-3 mb-5">
 <span className="w-8 h-8 rounded-lg bg-board-c/20 border border-board-c/30 flex items-center justify-center text-xs font-extrabold text-board-c">通</span>
 <div><h3 className="text-base font-semibold text-text-primary">通识</h3><p className="text-[11px] text-text-disabled">入门级 · 零基础可学 · 16 课时</p></div>
 </div>
 <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
 {KNOWLEDGE.junior.map((k) => (
 <div key={k.part} className="bg-panel-dark/40 border border-border-dark rounded-card mecha-card mecha-bolt p-3 hover:border-arena-blue/30 transition-all">
 <p className="text-[11px] font-semibold text-text-primary mb-1">{k.part}</p>
 <p className="text-[11px] text-text-secondary leading-relaxed mb-2">{k.concept}</p>
 <span className="text-[10px] px-1.5 py-0.5 rounded-tag" style={{backgroundColor: k.color+'20', color: k.color}}>{k.subject}</span>
 </div>
 ))}
 </div>
 </div>

 {/* 基础 3-4年级 */}
 <div className="mb-10">
 <div className="flex items-center gap-3 mb-5">
 <span className="w-8 h-8 rounded-lg bg-arena-blue/20 border border-arena-blue/30 flex items-center justify-center text-xs font-extrabold text-arena-blue">进</span>
 <div><h3 className="text-base font-semibold text-text-primary">进阶</h3><p className="text-[11px] text-text-disabled">入门之后 · 开始编程 · 16 课时</p></div>
 </div>
 <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
 {KNOWLEDGE.teen.map((k) => (
 <div key={k.part} className="bg-panel-dark/40 border border-border-dark rounded-card mecha-card mecha-bolt p-3 hover:border-arena-blue/30 transition-all">
 <p className="text-[11px] font-semibold text-text-primary mb-1">{k.part}</p>
 <p className="text-[11px] text-text-secondary leading-relaxed mb-2">{k.concept}</p>
 <span className="text-[10px] px-1.5 py-0.5 rounded-tag" style={{backgroundColor: k.color+'20', color: k.color}}>{k.subject}</span>
 </div>
 ))}
 </div>
 </div>

 {/* 进阶 5-6年级 */}
 <div className="mb-10">
 <div className="flex items-center gap-3 mb-5">
 <span className="w-8 h-8 rounded-lg bg-arena-gold/20 border border-arena-gold/30 flex items-center justify-center text-xs font-extrabold text-arena-gold">高</span>
 <div><h3 className="text-base font-semibold text-text-primary">高阶</h3><p className="text-[11px] text-text-disabled">完成进阶 · Python 与 AI · 16 课时</p></div>
 </div>
 <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
 {KNOWLEDGE.elite.map((k) => (
 <div key={k.part} className="bg-panel-dark/40 border border-border-dark rounded-card mecha-card mecha-bolt p-3 hover:border-arena-blue/30 transition-all">
 <p className="text-[11px] font-semibold text-text-primary mb-1">{k.part}</p>
 <p className="text-[11px] text-text-secondary leading-relaxed mb-2">{k.concept}</p>
 <span className="text-[10px] px-1.5 py-0.5 rounded-tag" style={{backgroundColor: k.color+'20', color: k.color}}>{k.subject}</span>
 </div>
 ))}
 </div>
 </div>

 {/* 菁英组 - 12 方向 */}
 <div className="mb-10">
 <div className="flex items-center gap-3 mb-5">
 <span className="w-8 h-8 rounded-lg bg-arena-red/20 border border-arena-red/30 flex items-center justify-center text-xs font-extrabold text-arena-red">菁</span>
 <div><h3 className="text-base font-semibold text-text-primary">菁英</h3><p className="text-[11px] text-text-disabled">初中及以上 · 12 个方向模块，每方向 16 课时，选 1-2 个深入学习</p></div>
 </div>
 <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
 {[
 { dir: '计算机视觉', desc: 'OpenCV 颜色识别→HSV色彩空间→轮廓检测→云台追踪→多目标区分', color: '#00C2FF' },
 { dir: '行为树 AI', desc: '优先级→并行→条件回退→从状态机到行为树的策略升级', color: '#FFB800' },
 { dir: '传感器融合', desc: '超声波+IMU+视觉——卡尔曼滤波加权平均，三个不准的传感器合起来比任何一个都准', color: '#A855F7' },
 { dir: '强化学习', desc: 'Agent 试错学习——不给规则，让车自己试1000次，撞翻+1 被撞-1 统计最优策略', color: '#FF3B3B' },
 { dir: 'CAD 3D 建模', desc: 'Fusion 360 草图→拉伸→旋转→切割→装配→工程图输出', color: '#00E676' },
 { dir: '3D 打印制造', desc: 'FDM 切层参数→支撑优化→材料选择(PLA/PETG/TPU)→后处理', color: '#00E676' },
 { dir: '端侧 AI 部署', desc: '训练 YOLO→量化压缩→部署到 NPU(A板K230)。Edge AI，离线实时推理', color: '#A855F7' },
 { dir: 'CAN 总线通信', desc: 'CAN 协议→数据帧格式→优先级仲裁→多设备同一根线通信', color: '#FF6D00' },
 { dir: 'SLAM 建图', desc: '激光雷达+深度摄像头→点云配准→占据栅格地图→定位与导航', color: '#00C2FF' },
 { dir: '运动学控制', desc: '麦轮正逆运动学→速度分解→PID 速度环+位置环双闭环控制', color: '#FFB800' },
 { dir: '机械结构设计', desc: '受力分析→材料力学直觉→拓扑优化→自研武器/装甲设计迭代', color: '#FF3B3B' },
 { dir: '工程循环实战', desc: '需求→设计→制作→测试→迭代。完整走一遍真正的工程设计循环', color: '#88929E' },
 ].map((d) => (
 <div key={d.dir} className="bg-panel-dark/40 border border-border-dark rounded-card mecha-card mecha-bolt p-4 hover:border-arena-blue/30 transition-all">
 <div className="flex items-center gap-2 mb-2"><div className="w-1.5 h-1.5 rounded-full shrink-0" style={{backgroundColor: d.color}}/><h3 className="text-sm font-semibold text-text-primary">{d.dir}</h3></div>
 <p className="text-[11px] text-text-secondary leading-relaxed">{d.desc}</p>
 </div>
 ))}
 </div>
 </div>

 {/* 极客组 */}
 <div className="mb-10">
 <div className="flex items-center gap-3 mb-5">
 <span className="w-8 h-8 rounded-lg bg-arena-red/20 border border-arena-red/30 flex items-center justify-center text-xs font-extrabold text-arena-red">极</span>
 <div><h3 className="text-base font-semibold text-text-primary">极客</h3><p className="text-[11px] text-text-disabled">大学社团 / 成人爱好者 · 自由项目制 · 不设固定课时</p></div>
 </div>
 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
 {[
 { dir: '自研整车', desc: '不依赖基础版底盘——从零设计整车。S板+无刷电机+高压电池+全定制结构。极客组赛场见。', color: '#FF3B3B' },
 { dir: 'ROS 机器人', desc: 'Linux (Debian) + ROS2 + Docker。SLAM导航、机械臂控制、多传感器融合——真正的机器人操作系统。', color: '#A855F7' },
 { dir: '集群协作', desc: '多车编队、分布式任务分配、Mesh自组网通信、群体智能决策——不是一辆车在战斗。', color: '#00C2FF' },
 { dir: 'AI 研究', desc: 'Sim-to-Real迁移学习、模仿学习、多智能体强化学习——可以做本科毕设和研究生课题的平台。', color: '#FFB800' },
 { dir: '开源贡献', desc: '为官方固件贡献代码、发布原创3D模型、撰写技术教程——从消费者变成共建者。', color: '#00E676' },
 { dir: '创业孵化', desc: '在社区积累作品和声誉后，自研配件上架商城。15%-20%佣金——这就是你的第一个创业项目。', color: '#FFB800' },
 ].map((d) => (
 <div key={d.dir} className="bg-panel-dark/40 border border-border-dark rounded-card mecha-card mecha-bolt p-5 flex gap-4">
 <div className="w-1.5 h-1.5 rounded-full mt-1.5 shrink-0" style={{backgroundColor: d.color}}/>
 <div>
 <h3 className="text-sm font-semibold text-text-primary mb-2">{d.dir}</h3>
 <p className="text-xs text-text-secondary leading-relaxed">{d.desc}</p>
 </div>
 </div>
 ))}
 </div>
 </div>
 <p className="text-center text-[11px] text-text-disabled mt-6">以上为部分知识点，每个阶段的内容远不止这些。</p>
 </section>

 {/* ---- Subject Coverage ---- */}
 <section className="px-6 py-12 max-w-6xl mx-auto">
 <h2 className="text-lg font-extrabold text-text-primary mb-4 text-center">学科覆盖</h2>
 <div className="flex flex-col lg:flex-row gap-4 mb-8">
	   {/* Left: 6 subjects in 3x2 grid */}
	   <div className="lg:w-3/5 grid grid-cols-2 sm:grid-cols-3 gap-3">
 {[{s:'物理',n:22,c:'#FF3B3B',items:'力/重心/传动/摩擦力/电学/振动/声波/动量/光学/运动学'},{s:'数学',n:22,c:'#00C2FF',items:'对称/比例/坐标/函数映射/统计/立体几何/向量/概率'},{s:'信息技术',n:21,c:'#FFB800',items:'图形化编程/Python/条件判断/循环/PID/状态机/I2C/GPIO/传感器融合'},{s:'通用技术',n:7,c:'#00E676',items:'装配/防呆设计/CAD建模/3D打印切片/工程设计循环'},{s:'化学',n:4,c:'#FF6D00',items:'锂电池原理/PLA高分子材料/硅橡胶特性/电化学基础'},{s:'英语',n:50,c:'#88929E',items:'Chassis/Gear Ratio/Torque/PID/AI/OpenCV——用到的才是自己的'}].map((subj)=>(<div key={subj.s} className="bg-panel-dark/40 border border-border-dark rounded-card mecha-card mecha-bolt p-3 hover:border-arena-blue/30 transition-all"><div className="flex items-center gap-1.5 mb-2"><div className="w-1.5 h-1.5 rounded-full shrink-0" style={{backgroundColor:subj.c}}/><span className="text-[11px] font-semibold text-text-primary whitespace-nowrap">{subj.s}</span><span className="text-[10px] text-text-disabled whitespace-nowrap">{subj.n}课时</span></div><p className="text-[10px] text-text-secondary leading-relaxed">{subj.items}</p></div>))}
   </div>
	   {/* Right: AI focus card - full height */}
	   <div className="lg:w-2/5 bg-panel-dark/40 border border-purple-500/30 rounded-card-lg mecha-card mecha-bolt p-6 flex flex-col justify-center relative overflow-hidden">
	     <div className="absolute top-3 right-3 text-[10px] px-2 py-0.5 rounded-tag bg-purple-500/15 text-purple-400 border border-purple-500/30">核心重点</div>
	     <div className="flex items-center gap-2 mb-3">
	       <div className="w-2 h-2 rounded-full shrink-0" style={{backgroundColor: "#A855F7"}} />
	       <span className="text-sm font-semibold text-text-primary">人工智能</span>
	       <span className="text-[10px] text-text-disabled">12 课时</span>
	     </div>
	     <p className="text-xs text-text-secondary leading-relaxed mb-4">if-else决策 / 有限状态机 / 行为树 / 计算机视觉 / 强化学习 / 神经网络部署 / 集群智能</p>
	     <p className="text-[11px] text-text-secondary/80 leading-relaxed mb-4">从6岁开始，每个阶段都融入AI概念——不是大学才学的内容。条件判断是AI的最原始形态，行为树是策略大脑，强化学习让车自己进化，端侧推理让模型跑在C板上。</p>
	     <div className="flex flex-wrap gap-2">
	       {["条件判断→AI决策", "状态机→AI大脑", "行为树→AI策略", "计算机视觉→AI眼睛", "强化学习→AI进化", "端侧推理→Edge AI"].map((t) => (<span key={t} className="text-[10px] text-purple-400/70 bg-purple-500/10 px-2 py-1 rounded-tag">{t}</span>))}
	     </div>
	   </div>
 </div>
 </section>
{/* ---- AI Pathway ---- */}
 <section className="px-6 py-12 max-w-6xl mx-auto">
 <h2 className="text-lg font-extrabold text-text-primary mb-2 text-center">人工智能进化路径</h2>
 <p className="text-xs text-text-secondary mb-8 text-center">从 if-else 到集群智能——每个孩子都能在这条路上找到自己的位置。这不是大学才学的内容——6 岁已经在路上。</p>
 <div className="relative mb-6">
 {/* Timeline line */}
 <div className="hidden md:block absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-[3px] bg-arena-blue/25" />
 <div className="space-y-4">
 {AI_PATHWAY.map((item, i) => (
 <div key={item.stage} className={`flex items-center gap-4 ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
 <div className={`flex-1 ${i % 2 === 0 ? 'md:text-right' : 'md:text-left'} hidden md:block`}>
 <div className="bg-panel-dark/40 border border-border-dark rounded-card mecha-card mecha-bolt p-4 inline-block max-w-sm">
 <p className="text-xs text-text-secondary leading-relaxed">{item.desc}</p>
 </div>
 </div>
 <div className="shrink-0 relative z-10">
 <div className="w-3 h-3 rounded-full bg-arena-blue ring-4 ring-bg-black" />
 </div>
 <div className={`flex-1 ${i % 2 === 0 ? 'md:text-left' : 'md:text-right'}`}>
 <div className="bg-panel-dark/40 border border-arena-blue/20 rounded-card mecha-card mecha-bolt p-4 inline-block max-w-sm">
 <div className="flex items-center gap-2 mb-1">
 <span className="text-[10px] px-1.5 py-0.5 rounded-tag bg-arena-blue/15 text-arena-blue">{item.level}</span>
 <h3 className="text-sm font-semibold text-text-primary">{item.stage}</h3>
 </div>
 <p className="text-xs text-text-secondary leading-relaxed md:hidden">{item.desc}</p>
 </div>
 </div>
 </div>
 ))}
 </div>
 </div>
 </section>


	{/* ---- School Program ---- */}
	 <section className="px-6 py-12 max-w-6xl mx-auto">
	 <h2 className="text-lg font-extrabold text-text-primary mb-2 text-center">学校课程方案</h2>
	 <p className="text-xs text-text-secondary mb-8 text-center">从小学信息技术课到大学机器人社团，一套硬件体系覆盖全学段。按需配置，按级递进。</p>

	 <div className="overflow-x-auto mb-8">
	 <table className="w-full text-sm border-collapse">
	 <thead><tr className="border-b-2 border-border-dark"><th className="text-left py-2.5 px-3 text-text-disabled font-medium text-xs">项目阶段</th><th className="text-left py-2.5 px-3 text-text-disabled font-medium text-xs">适用年级</th><th className="text-left py-2.5 px-3 text-text-disabled font-medium text-xs">主板</th><th className="text-left py-2.5 px-3 text-text-disabled font-medium text-xs">学期课时</th><th className="text-left py-2.5 px-3 text-text-disabled font-medium text-xs">相关硬件</th><th className="text-left py-2.5 px-3 text-text-disabled font-medium text-xs">竞技参与</th><th className="text-left py-2.5 px-3 text-text-disabled font-medium text-xs">成果产出</th></tr></thead>
	 <tbody className="text-text-secondary text-xs">
	 {[
	 ["通识","1-2年级","Demo 车","12项目+2备战+2竞赛","360舵机·驱动电机·主板·电池·LED·轮胎等","竞速比赛","拼装日记+操控视频"],
	 ["进阶","3-4年级","C→B 板","12项目+2备战+2竞赛","B板·红外·超声波·颜色传感器·摄像头等","自由对战→校内联赛","程序源码+改装方案"],
	 ["高阶","5-6年级","B→A 板","12项目+2备战+2竞赛","A板·OV5640·3D打印机·推铲装甲等","校内联赛","Python项目+3D设计"],
	 ["菁英","7-9年级","A 板","12项目+2备战+2竞赛","A板·K230 NPU·激光雷达·双轴云台等","官方认证赛","竞赛成绩+学术论文"],
	 ["极客","10年级+/成人","S 板","不限课时","S板·无刷电机·高压电池·双目摄像头等","官方赛+自研","自研整车+开源贡献"],
	 ].map((r,i)=>(<tr key={i} className="border-b border-border-dark/50 hover:bg-panel-mid/50 transition-colors"><td className="py-2.5 px-3 font-medium text-text-primary">{r[0]}</td><td className="py-2.5 px-3">{r[1]}</td><td className="py-2.5 px-3 text-arena-blue">{r[2]}</td><td className="py-2.5 px-3">{r[3]}</td><td className="py-2.5 px-3 text-[11px]">{r[4]}</td><td className="py-2.5 px-3">{r[5]}</td><td className="py-2.5 px-3">{r[6]}</td></tr>))}
	 </tbody>
	 </table>
	 </div>



	 <h3 className="text-sm font-semibold text-text-primary mb-3 text-center">场景速查</h3>
	 <div className="overflow-x-auto">
	 <table className="w-full text-xs border-collapse">
	 <thead><tr className="border-b-2 border-border-dark"><th className="text-left py-2 px-3 text-text-disabled font-medium">场景</th><th className="text-left py-2 px-3 text-text-disabled font-medium">项目阶段</th><th className="text-left py-2 px-3 text-text-disabled font-medium">主板</th><th className="text-left py-2 px-3 text-text-disabled font-medium">建议课时</th><th className="text-left py-2 px-3 text-text-disabled font-medium">可参赛事</th></tr></thead>
	 <tbody className="text-text-secondary">
	 {[
	 ["小学课后兴趣班","通识","C","16","自由对战"],
	 ["小学正课（信息技术）","通识","C","16","自由对战"],
	 ["小学社团/竞赛队","通识→进阶","C→B","32","自由对战→校内联赛"],
	 ["初中社团","进阶→高阶","B","32","校内联赛"],
	 ["初中竞赛队","高阶→菁英","B→A","48","官方认证赛"],
	 ["高中竞赛队","菁英","A","48","官方认证赛"],
	 ["高中通用技术课","高阶","B","16","校内联赛"],
	 ["大学社团","菁英→极客","A→S","自由","官方赛+自研"],
	 ["青少年宫/培训机构","通识→菁英","C→A","16-64","自由对战→官方认证赛"],
	 ].map((r,i)=>(<tr key={i} className="border-b border-border-dark/50 hover:bg-panel-mid/50"><td className="py-2 px-3 text-text-primary">{r[0]}</td><td className="py-2 px-3">{r[1]}</td><td className="py-2 px-3 text-arena-blue">{r[2]}</td><td className="py-2 px-3">{r[3]}</td><td className="py-2 px-3">{r[4]}</td></tr>))}
	 </tbody>
	 </table>
	 </div>
	 </section>

{/* ---- Skill Certification ---- */}
 <section className="px-6 py-12 max-w-6xl mx-auto">
 <h2 className="text-lg font-extrabold text-text-primary mb-4 text-center">技能认证 · 成长路径</h2>
 <p className="text-xs text-text-secondary mb-6 text-center">L1到L8，从拼装到创新大师。每个等级对应可量化的能力标准，通过认证考试解锁。</p>
 <div className="bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt p-6 mb-6"><div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">{CERT_LEVELS.map((cert,i)=>(<div key={cert.level} className="text-center"><div className={`w-9 h-9 mx-auto mb-2 rounded-full flex items-center justify-center border-2 text-xs font-extrabold font-mono ${i<=1?'bg-arena-gold/20 border-arena-gold text-arena-gold':i===2?'bg-arena-gold/10 border-arena-gold/50 text-arena-gold animate-breath':'bg-transparent border-border-dark text-text-disabled'}`}>L{cert.level}</div><p className={`text-[11px] font-medium ${i<=2?'text-text-primary':'text-text-disabled'}`}>{cert.title}</p><p className="text-[10px] text-text-disabled mt-0.5 leading-tight">{cert.description}</p></div>))}</div><div className="text-center mt-6"><button className="px-5 h-9 rounded-btn bg-arena-gold text-bg-black text-sm font-medium hover:brightness-110 transition-all">参加认证考试</button></div></div>
 </section>

 

 {/* ---- Teacher Support ---- */}
 <section className="px-6 pb-16 max-w-6xl mx-auto">
 <h2 className="text-lg font-extrabold text-text-primary mb-4 text-center">教师支持</h2>
 <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
 {[{t:'完整教学材料',d:'每课时配备课程指南+实验手册+操作演示视频（扫码即看）'},{t:'零基础教师培训',d:'1天线下或2天线上，手把手拼第一台车、写第一行程序'},{t:'在线答疑',d:'微信群+每周直播答疑，任何问题当天答复'},{t:'课程迭代',d:'每年更新教案和实验内容，已购学校免费升级'}].map((s)=>(<div key={s.t} className="bg-panel-dark/40 border border-border-dark rounded-card mecha-card mecha-bolt p-4"><h3 className="text-sm font-semibold text-text-primary mb-2">{s.t}</h3><p className="text-xs text-text-secondary leading-relaxed">{s.d}</p></div>))}
 </div>
 </section>
 </div>
 );
}
